import fetchServer from "../helpers/api/fetchServer";

/** Empty array → `null` so PATCH can $unset targeting fields on the server. */
const targetingIdsOrNull = (ids) => {
  if (ids === undefined) return undefined;
  return ids.length === 0 ? null : ids;
};

/** Omit property on create when the id array is empty or undefined. */
const targetingFieldIfNonempty = (key, ids) =>
  ids?.length ? { [key]: ids } : {};

export const createAdGroupTemplate = async ({
  setupTemplateId,
  name,
  includedAudienceIds,
  excludedAudienceIds,
  includedInterestIds,
  includedInterestGroupIds,
}) => {
  const method = "POST";
  const urlAPI = "/api/adGroupTemplates";
  const body = {
    setupTemplate: setupTemplateId,
    name,
    ...targetingFieldIfNonempty("includedAudiences", includedAudienceIds),
    ...targetingFieldIfNonempty("excludedAudiences", excludedAudienceIds),
    ...targetingFieldIfNonempty("includedInterests", includedInterestIds),
    ...targetingFieldIfNonempty(
      "includedInterestGroups",
      includedInterestGroupIds,
    ),
  };
  return await fetchServer({ method, urlAPI, body });
};

export const getAdGroupTemplates = async () => {
  const method = "GET";
  const urlAPI = "/api/adGroupTemplates";
  return await fetchServer({ method, urlAPI });
};

export const getAdGroupTemplatesBySetupTemplate = async (setupTemplateId) => {
  const method = "GET";
  const urlAPI = `/api/adGroupTemplates?setupTemplate=${setupTemplateId}`;
  return await fetchServer({ method, urlAPI });
};

export const getAdGroupTemplate = async (id) => {
  const method = "GET";
  const urlAPI = `/api/adGroupTemplates/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const updateAdGroupTemplate = async ({
  id,
  name,
  setupTemplateId,
  includedAudienceIds,
  excludedAudienceIds,
  includedInterestIds,
  includedInterestGroupIds,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/adGroupTemplates/${id}`;
  const body = {
    name,
    setupTemplate: setupTemplateId,
    includedAudiences: targetingIdsOrNull(includedAudienceIds),
    excludedAudiences: targetingIdsOrNull(excludedAudienceIds),
    includedInterests: targetingIdsOrNull(includedInterestIds),
    includedInterestGroups: targetingIdsOrNull(includedInterestGroupIds),
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updateAdGroupTemplateGeneral = async ({
  id,
  name,
  setupTemplateId,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/adGroupTemplates/${id}`;
  const body = {
    name,
    setupTemplate: setupTemplateId,
  };
  return await fetchServer({ method, urlAPI, body });
};


export const updateAdGroupTemplateAudiences = async ({
  id,
  includedAudienceIds,
  excludedAudienceIds,
  includedInterestIds,
  includedInterestGroupIds,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/adGroupTemplates/${id}`;
  const body = {
    includedAudiences: targetingIdsOrNull(includedAudienceIds),
    excludedAudiences: targetingIdsOrNull(excludedAudienceIds),
    includedInterests: targetingIdsOrNull(includedInterestIds),
    includedInterestGroups: targetingIdsOrNull(includedInterestGroupIds),
  };
  return await fetchServer({ method, urlAPI, body });
};

export const deleteAdGroupTemplate = async (id) => {
  const method = "DELETE";
  const urlAPI = `/api/adGroupTemplates/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const restoreAdGroupTemplate = async (id) => {
  const method = "POST";
  const urlAPI = `/api/adGroupTemplates/${id}/restore`;
  return await fetchServer({ method, urlAPI });
};

export const deleteAdGroupTemplates = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/adGroupTemplates/bulk-delete";
  const body = { ids };
  return await fetchServer({ method, urlAPI, body });
};

export const restoreAdGroupTemplates = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/adGroupTemplates/bulk-restore";
  const body = { ids };
  return await fetchServer({ method, urlAPI, body });
};
